import React, { useRef } from 'react';
import { Navbar } from '../src/Navbar';
import { HeroSlider } from '../src/HeroSlider';
import { AboutSection } from '../src/AboutSection';
import { Footer } from '../src/Footer';
import { LanguageProvider } from './i18n/LanguageContext';
import './style.css';

const App: React.FC = () => {
  const aboutRef = useRef<HTMLDivElement>(null);

  const scrollToAbout = () => {
    if (aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-brand-black text-white font-sans selection:bg-brand-gold selection:text-black">
        <Navbar onAboutClick={scrollToAbout} />
        <main>
          <HeroSlider />
          <video controls autoplay src="https://wyndme.cn/video/website-home.mp4" poster="images/cover.jpg" ></video>
          <AboutSection ref={aboutRef} />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
};

export default App;
